import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContClientsSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 80px 0 180px 0;
  background: #2B2B2B;

  @media(min-width: 300px) and (max-width: 767px){
    padding: 60px 0;
  }
`;

export const TitleClients = styled.h2`
  font-family: ${GlobalFonts.fontBold};
  font-size: 48px;
  line-height: 56px;
  text-align: center;
  color: ${GlobalColors.colorPrimary};
  margin-bottom: 60px;
  padding: 0 0 80px 0;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 40px;
  }
`;

export const ClientsGrid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 60px;
  width: 100%;

  @media(min-width: 300px) and (max-width: 767px){
    gap: 40px;
    width: 90%;
  }
`;

export const ClientItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClientLogo = styled.img`
  filter: grayscale(100%);
  transition: all 0.3s ease;

  ${ClientItem}:hover & {
    filter: grayscale(0%);
    opacity: 1;
  }

  @media(min-width: 300px) and (max-width: 767px){
  }
`;
